import React, { useState, useEffect } from "react";
import { useAuth } from "react-oidc-context";
import styles from "../POIList/POIList.module.css";
import {
    DefaultButton,
    PrimaryButton,
    IStackTokens,
    Stack,
    StackItem,
    TextField,
    Dialog,
    DialogType,
    DialogFooter,
    IDatePicker,
    DatePicker, defaultDatePickerStrings
} from "@fluentui/react";
import { Dropdown, IDropdownOption } from "@fluentui/react/lib/Dropdown";
import { initializeIcons } from "@fluentui/font-icons-mdl2";
import strings from "../../../loc/strings";
import { UpdateAssessmentById, CreateAssessment } from "../../../services/ManageSystemServices/POIService";
import { AssessmentItem } from "../../../model/ManagePOIListItem";
import { fetchEUSLB } from "../../../services/AdminServices/EUSLBService";
import { EIOPAError } from "../../../model/EIOPAError";
import { getUserInfo } from "../../../services/UserInfoService";

initializeIcons();

const onFormatDate = (date?: Date): string => {
    if (date) {
        let day = date.getDate();
        let month = date.getMonth() + 1;
        let dayString = day < 10 ? '0' + day.toString() : day.toString();
        let monthString = month < 10 ? '0' + month.toString() : month.toString();

        return dayString + '/' + monthString + '/' + date.getFullYear();
    }

    return '';
};

const stackTokens: IStackTokens = { childrenGap: 20 };

function AddEditDialog(props: any) {
    const auth = useAuth();

    const initialAssessment = {
        "id": undefined,
        "personId": props.POIId,
        "assessingCAId": null,
        "internalCARefNo": null,
        "euSectoralLegislatureBasisId": null,
        "euSectoralLegislatureBasis": null,
        "dateOfAssessment": null,
        "createdDate": new Date().toISOString(),
        "createdBy": auth.user?.profile.email,
        "markedForDeletionDate": null,
    };

    const [addEditItem, setAddEditItem] = React.useState<AssessmentItem>({ ...props.item, dateOfAssessment: props.dateOfAssessment != null ? props.dateOfAssessment : new Date() });
    const [error, setError] = useState('');
    const [dateIsValid, setDateIsValid] = useState(true);

    useEffect(() => {
        setAddEditItem({ ...props.item });
    }, [props.item]);

    const handleSubmit = (event: any) => {
        event.preventDefault();
    }

    const resetField = () => {
        setAddEditItem({ ...initialAssessment });
    }

    const handleDialogClose = () => {
        props.setDialogIsHidden(true);
        setError('');
        resetField();
    };

    let userInfo = getUserInfo(auth.user?.id_token);

    const handleDialogSave = (id: string, item: AssessmentItem) => {
        if (item.dateOfAssessment === null || item.dateOfAssessment === undefined || item.dateOfAssessment === '' || !dateIsValid) {
            setError('Add Date of assessment');
        } else if (item.euSectoralLegislatureBasisId === null || item.euSectoralLegislatureBasisId === undefined) {
            setError('Add EU sectoral legislative basis');
        } else {

            if (id !== "0") {
                Object.keys(item).forEach((k) => item[k as keyof AssessmentItem] == "" && delete item[k as keyof AssessmentItem]);

                if (item.euSectoralLegislatureBasis?.name) {
                    delete (item.euSectoralLegislatureBasis as any).name;
                }
                if ("name" in item) {
                    delete item.name;
                }

                UpdateAssessmentById(id, item, auth.user?.id_token)
                    .then((response) => {
                        // Successful update, handle the response accordingly
                        console.log('Assessment item updated successfully:', response);
                        // Update the user interface, refresh the data list, etc.
                        if (response == true) {
                            resetField();
                            props.handleActionResponse('assessedittrue');
                            handleDialogClose();
                        } else {
                            if (response == 'The edited assessment already exists in the system') {
                                console.error('Error updating Assessment item:', response);
                                props.handleActionResponse('assesseditexist');
                            }
                            else {
                                console.error('Error updating Assessment item:', response);
                                props.handleActionResponse('assesseditfalse');
                                resetField();
                            }
                        }
                    })
                    .catch((error) => {
                        // If there is an error during update, handle it
                        console.error('Error updating Assessment item:', error);
                        resetField();
                        let fallbackMessage = strings.assessmentDefaultErrorMessage;
                        let serverErrorMessage = fallbackMessage;

                        if (error instanceof EIOPAError) {
                            const rawMessage = error.message;

                            if (rawMessage === 'The edited assessment already exists in the system') {
                                serverErrorMessage = "assesseditexist";
                                props.handleActionResponse(serverErrorMessage);
                                return;
                            } else {
                                try {
                                    const parsed = JSON.parse(rawMessage);
                                    if (Array.isArray(parsed.errors) && parsed.errors.length > 0) {
                                        serverErrorMessage = parsed.errors[0];
                                        props.handleActionResponse('error', serverErrorMessage);
                                        return;
                                    }
                                } catch (parseError) {
                                    console.error("Failed to parse EIOPAError message as JSON:", parseError);
                                }
                            }
                        }

                        props.handleActionResponse('assesseditfalse');

                    });
                handleDialogClose();
            }
            else {
                item.assessingCAId = userInfo.ncaCode;
                item.personId = props.POIId;
                Object.keys(item).forEach((k) => item[k as keyof AssessmentItem] == null && delete item[k as keyof AssessmentItem]);
                Object.keys(item).forEach((k) => item[k as keyof AssessmentItem] == undefined && delete item[k as keyof AssessmentItem]);
                Object.keys(item).forEach((k) => item[k as keyof AssessmentItem] == "" && delete item[k as keyof AssessmentItem]);
                setAddEditItem(item);
                CreateAssessment(item, auth.user?.id_token)
                    .then((response) => {
                        // Successful create, handle the response accordingly
                        console.log('Assessment item created successfully:', response);
                        // Update the user interface, refresh the data list, etc.
                        if (response == true) {
                            resetField();
                            props.handleActionResponse('assesscreatetrue');
                            handleDialogClose();
                        } else {
                            if (response == 'The Assessment you are trying to create, already exists in the system') {
                                console.error('Error creating Assessment item:', response);
                                props.handleActionResponse('assesscreateexist');
                            }
                            else {
                                console.error('Error creating Assessment item:', response);
                                props.handleActionResponse('assesscreatefalse');
                                resetField();
                            }
                        }
                    })
                    .catch((error) => {
                        // If there is an error during update, handle it
                        console.error('Error creating Assessment item:', error);
                        resetField();
                        let fallbackMessage = strings.assessmentDefaultErrorMessage;
                        let serverErrorMessage = fallbackMessage;

                        if (error instanceof EIOPAError) {
                            const rawMessage = error.message;

                            if (rawMessage === 'The Assessment you are trying to create, already exists in the system') {
                                serverErrorMessage = "assesscreateexist";
                                props.handleActionResponse(serverErrorMessage);
                                return;
                            } else {
                                try {
                                    const parsed = JSON.parse(rawMessage);
                                    if (Array.isArray(parsed.errors) && parsed.errors.length > 0) {
                                        serverErrorMessage = parsed.errors[0];
                                        props.handleActionResponse('error', serverErrorMessage);
                                        return;
                                    }
                                } catch (parseError) {
                                    console.error("Failed to parse EIOPAError message as JSON:", parseError);
                                }
                            }
                        } else {
                            try {
                                const parsed = JSON.parse(error.message);
                                if (Array.isArray(parsed.errors) && parsed.errors.length > 0) {
                                    serverErrorMessage = parsed.errors[0];
                                    props.handleActionResponse('error', serverErrorMessage);
                                    return;
                                }
                            } catch (parseErr) {
                                console.error("Failed to parse error message as JSON:", parseErr);
                            }
                        }

                        props.handleActionResponse('assesscreatefalse');
                        resetField();
                    });
                handleDialogClose();
            }
        }
    };

    // Dialog Edit Assessment
    const dialogContentPropsEdit = {
        type: DialogType.normal,
        title: props.title,
    };

    const modalPropsEdit = React.useMemo(
        () => ({
            isBlocking: true,
        }),
        [],
    );

    let actionDis: boolean = false;
    if (props.item != null) {
        actionDis = true;
    }

    return (
        <div className="Assessment">
            <form onSubmit={handleSubmit}>
                <Dialog
                    hidden={props.dialogIsHidden}
                    onDismiss={handleDialogClose}
                    dialogContentProps={dialogContentPropsEdit}
                    modalProps={modalPropsEdit}
                    minWidth="560px"
                >
                    <Assessment addEditItem={addEditItem} setAddEditItem={setAddEditItem} date={props.dateOfAssessment} error={error} dateIsValid={setDateIsValid} />
                    <DialogFooter>
                        <PrimaryButton onClick={() => handleDialogSave(addEditItem.encryptedId ? addEditItem.encryptedId : "0", addEditItem)} text={props.isAdd ? 'Add' : 'Save'} />
                        <DefaultButton onClick={handleDialogClose} text="Cancel" />
                    </DialogFooter>
                </Dialog>
            </form>
        </div>

    );
}

function Assessment(props: any) {

    const auth = useAuth();

    const datePickerRef = React.useRef<IDatePicker>(null);
    const [DOAssessment, setDOAssessment] = useState<Date | undefined>(props.date ?? new Date());
    const [type, setType] = React.useState<IDropdownOption[]>([]);
    const [changedDate, setChangedDate] = useState({
        date: new Date(),
        error: false,
        message: ''
    });
    let [dateString, setDateString] = useState<string | undefined>(undefined);

    useEffect(() => {
        if (props.addEditItem.dateOfAssessment == null) {
            props.setAddEditItem({ ...props.addEditItem, dateOfAssessment: new Date().toLocaleDateString('fr-BE') });
        }
        // Fetch EUSLB data from the API
        (async function () {
            const result = await fetchEUSLB("1", auth.user?.id_token);
            const filteredResult = result.sort((a, b) => a.name.localeCompare(b.name)).filter(item => item.active === true);

            const newArrayOfObj = filteredResult.map(({
                id: key,
                name: text,
            }) => ({
                key,
                text
            }));
            setType(newArrayOfObj);
        })();
    }, []);

    const onChangeField = (event: any) => {
        props.setAddEditItem({ ...props.addEditItem, [event.target.name]: event.target.value.trim().length > 0 ? event.target.value.trim() : null });
    }

    const onChangeDate = (event: any) => {
        let typedDate = onParseDateFromString(dateString);
        let dateToChange;
        if (event !== typedDate) {
            dateToChange = event;
        } else {
            dateToChange = typedDate;
        }
        if (dateString && !typedDate) {
            setDOAssessment(undefined);
            setChangedDate({ ...changedDate, error: true, message: 'Invalid date format' })
            props.dateIsValid(false);
            props.setAddEditItem({ ...props.addEditItem, dateOfAssessment: undefined });
        } else {
            let date;
            if (!Number.isNaN(Date.parse(dateToChange))) {
                date = new Date(Date.parse(dateToChange));
            }
            let newDate = date === undefined ? undefined : new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
            setDOAssessment(newDate);
            setChangedDate({ ...changedDate, error: false, message: '' })
            props.dateIsValid(!!newDate);
            props.setAddEditItem({ ...props.addEditItem, dateOfAssessment: newDate?.toLocaleDateString('fr-BE') });
        }
        setDateString(undefined)
    }

    // const currrentDate = () => {
    //     let date = new Date();
    //     return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
    // }

    let actionDis: boolean = false;
    if (props.item != null) {
        actionDis = true;
    }

    const onChangeDropdown = (event: any, option: any, index: any) => {
        props.setAddEditItem({ ...props.addEditItem, euSectoralLegislatureBasisId: option.key });
    };

    const onParseDateFromString = (newValue: string | undefined): Date | null => {
        if (newValue) {
            const dateRegex = /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[012])\/\d{4}$/;
            if (dateRegex.test(newValue)) {
                const newValueParts = newValue.trim().split('/');
                const day = Math.max(1, Math.min(31, Number.parseInt(newValueParts[0], 10)));
                const month = Math.max(1, Math.min(12, Number.parseInt(newValueParts[1], 10))) - 1;
                let year = Number.parseInt(newValueParts[2], 10);
                let isFutureDate = new Date(year, month, day) > new Date();
                setChangedDate({ ...changedDate, date: new Date(year, month, day), error: isFutureDate, message: isFutureDate ? 'Future dates are not permitted' : '' })
                props.dateIsValid(!isFutureDate);
                return new Date(year, month, day);
            }
        }
        return null;
    }

    return (
        <div>
            <Stack horizontal tokens={stackTokens}>
                <StackItem grow={2}>
                    <TextField label={strings.POIListAssessmentIntAssessNo} defaultValue={props.addEditItem.internalCARefNo || ""} name="internalCARefNo" placeholder="Type number" className={styles.inputField} onChange={onChangeField} maxLength={500} />
                </StackItem>
                <StackItem grow={2}>
                    <DatePicker
                        componentRef={datePickerRef}
                        label={strings.addNewAssessmentSelectDate}
                        value={DOAssessment}
                        placeholder={strings.datepickerPlaceholder}
                        formatDate={onFormatDate}
                        className={styles.inputField}
                        onSelectDate={onChangeDate}
                        maxDate={new Date()}
                        isRequired
                        textField={{
                            onNotifyValidationResult: (errorMessage, value) => {
                                setDateString(value)
                            },
                            errorMessage: changedDate.date && changedDate.error ? changedDate.message : !DOAssessment && props.error ? "Field is required" : ""
                        }}
                        allowTextInput
                        styles={{
                            statusMessage: {
                                display: 'none'
                            }
                        }}
                        parseDateFromString={(dateStr: string) => {
                            dateString = dateStr;
                            return onParseDateFromString(dateStr);
                        }}
                        strings={{ ...defaultDatePickerStrings, isOutOfBoundsErrorMessage: "Future dates are not allowed" }}
                    />
                </StackItem>
            </Stack>
            <Stack horizontal tokens={stackTokens}>
                <StackItem grow={2}>
                    <Stack horizontal tokens={stackTokens}>
                        <Dropdown
                            label={strings.requestForInfoEUSecLegBasis}
                            options={type}
                            defaultSelectedKey={props.addEditItem.euSectoralLegislatureBasisId}
                            disabled={actionDis}
                            onChange={onChangeDropdown}
                            className={styles.inputFieldFull}
                            required
                            placeholder={'Select basis'}
                            errorMessage={!props.addEditItem.euSectoralLegislatureBasisId && props.error ? "Field is required" : ""}
                        />
                    </Stack>
                </StackItem>
            </Stack>
        </div>
    );
};

export default AddEditDialog;
